var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas",staticStyle:{"border":"1px solid #ccc"},attrs:{"width":_vm.canvasSize,"height":_vm.canvasSize}})])}
var staticRenderFns = []

export { render, staticRenderFns }